import { render, staticRenderFns } from "./QuestionRateModal.vue?vue&type=template&id=0fbaaee8"
import script from "./QuestionRateModal.vue?vue&type=script&lang=js"
export * from "./QuestionRateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports